import API from "./index"

class ItemRepositorioDocumentoService {
  constructor() {
    this.path = `/api/itemmanuaisroteirosatos`
  }

  async findAll({ page = 0, size = 10, descricao = "", situacao = null }) {
    page = page - 1 < 0 ? 0 : page - 1
    const params = {
      page: page - 1 < 0 ? 0 : page - 1,
      size: size,
    }

    if (descricao !== "") {
      params.descricao = descricao
    }
    if (situacao !== null) {
      params.situacao = situacao
    }
    return await API.get(this.path, { params })
  }
  async find() {
    return await API.get(`${this.path}`)
  }
  async findById(id) {
    return await API.get(`${this.path}/${id}`)
  }

  async save(record) {
    if (record.id) {
      return await API.put(`${this.path}/${record.id}`, record).then(
        ({ ...args }) => ({ created: false, ...args })
      )
    }

    return API.post(this.path, record).then(({ ...args }) => ({
      created: true,
      ...args,
    }))
  }

  async alteraSituacao({ id, situacao }) {
    return await API.put(`${this.path}/${id}/situacao`, { situacao }).then(
      ({ ...args }) => ({ created: false, ...args })
    )
  }

  async remove(id) {
    if (!id) {
      throw new Error("ID cannot be null")
    }
    return await API.delete(`${this.path}/${id}`)
  }
}
export default ItemRepositorioDocumentoService
